import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight, FiAward, FiHeart, FiGlobe, FiZap } from 'react-icons/fi';

const values = [
  { icon: <FiAward />, title: 'Premium Quality', desc: 'Every product is hand-selected for excellence in craftsmanship and materials.' },
  { icon: <FiHeart />, title: 'Customer First', desc: 'We build lasting relationships through exceptional service and genuine care.' },
  { icon: <FiGlobe />, title: 'Sustainable', desc: 'Committed to eco-friendly practices and ethical sourcing across our supply chain.' },
  { icon: <FiZap />, title: 'Innovation', desc: 'Constantly evolving to bring you the latest in technology and design trends.' },
];

const About = () => {
  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="container">
          <motion.div
            className="about-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <span className="hero-badge">Our Story</span>
            <h1 className="about-title">
              Redefining Premium
              <span className="hero-gradient"> Shopping</span>
            </h1>
            <p className="about-subtitle">
              Born from a passion for quality and a belief that everyone deserves access
              to the world's finest products. We've been curating exceptional experiences since 2020.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Mission */}
      <section className="mission-section section">
        <div className="container">
          <div className="mission-grid">
            <motion.div
              className="mission-text"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2>Our Mission</h2>
              <p>
                At Luxora, we believe that premium quality shouldn't be a privilege.
                We work directly with the world's finest brands and craftspeople to bring
                you products that inspire, perform, and last.
              </p>
              <p>
                Every item in our collection passes through our rigorous quality standards,
                ensuring you receive nothing but the best when your package arrives.
              </p>
              <Link to="/shop" className="btn btn-primary">
                Shop Now <FiArrowRight />
              </Link>
            </motion.div>
            <motion.div
              className="mission-stats"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              {[
                { value: '6+', label: 'Years of Excellence' },
                { value: '50K+', label: 'Happy Customers' },
                { value: '2K+', label: 'Premium Products' },
                { value: '120+', label: 'Brand Partners' },
              ].map(stat => (
                <div key={stat.label} className="about-stat">
                  <span className="about-stat-value">{stat.value}</span>
                  <span className="about-stat-label">{stat.label}</span>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="values-section section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Our Values</h2>
            <p className="section-subtitle">What drives everything we do</p>
          </motion.div>
          <div className="values-grid">
            {values.map((v, i) => (
              <motion.div
                key={i}
                className="value-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                whileHover={{ y: -6 }}
              >
                <div className="value-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      {/* <section className="team-section section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Meet the Team</h2>
            <p className="section-subtitle">The passionate people behind Luxora</p>
          </motion.div>
          <div className="team-grid">
            {teamMembers.map((member, i) => (
              <motion.div
                key={i}
                className="team-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                whileHover={{ y: -6 }}
              >
                <div className="team-avatar">{member.emoji}</div>
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA */}
      <section className="about-cta section">
        <div className="container">
          <motion.div
            className="cta-card"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <h2>Ready to Experience LuanLogistics?</h2>
            <p>Join 50,000+ customers who trust us for their premium shopping needs.</p>
            <div className="cta-actions">
              <Link to="/shop" className="btn btn-primary btn-lg">
                Explore the Collection
              </Link>
              <a href="mailto:hello@luxora.shop" className="btn btn-outline btn-lg">
                Get in Touch
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;
